import styled from "styled-components";
import { theme } from "../../../constants/StyledComponents";

export const StyledRow = styled.div`
  display: contents;

  &.sticky-row > div {
    position: sticky;
    background: white;
    z-index: 10;
  }

  &.top-row-1 > div {
    top: 0;
  }

  &.top-row-2 > div {
    top: 91px;
  }

  &.top-row-3 > div {
    top: 170px;
    padding: 0 20px;

    & > div {
      padding: 20px 0;
      border-bottom: 1px solid ${theme.colors.purple_2};
    }
  }

  & > .section-box {
    padding: 20px 20px 0px 20px;

    & > div {
      padding-bottom: 20px;
      position: relative;
      border-bottom: 1px solid ${theme.colors.purple_2};
    }

    &:first-child {
      border-right: 1px solid ${theme.colors.purple_2};
    }
  }
`;

export const StyledGridComparison = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  align-items: stretch;
  overflow-y: auto;
  height: calc(100% - 72px);
`;
